<template>
  <div>
    <Breadcrumb msg1="报表中心" msg2="库存报表" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 15px">
        <el-col :span="6">
          <el-select v-model="category_id" placeholder="选择分类" clearable>
            <el-option v-for="c in categories" :key="c.id" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="getData">统计</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border size="small">
        <el-table-column label="商品" prop="productName" width="200"></el-table-column>
        <el-table-column label="规格" prop="sku"></el-table-column>
        <el-table-column label="库存" prop="stock" width="100"></el-table-column>
        <el-table-column label="成本金额" prop="costAmount" width="120"></el-table-column>
        <el-table-column label="零售金额" prop="retailAmount" width="120"></el-table-column>
        <el-table-column label="是否预警" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.alertCount > 0" type="danger">预警</el-tag>
            <el-tag v-else type="success">正常</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      category_id: null,
      list: [],
      categories: []
    }
  },
  created () {
    this.getData()
    this.$axios.http.get('/categories').then(r => { if (r.data.status === 200) this.categories = r.data.data || [] })
  },
  methods: {
    getData () {
      this.$axios.http.get('/reports/inventory', { params: { category_id: this.category_id } }).then(r => {
        if (r.data.status === 200) this.list = r.data.data || []
      })
    }
  }
}
</script>
